import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@one-thd/sui-atomic-components';
import { SectionHeader } from '../shared/section-header/SectionHeader';
import { useBusinessToolsContext, useCommonContext, } from '../../hooks/useContexts';
import { BusinessToolsErrorMessage } from './BuisnessToolsErrorMessage';
import { getSvocId, getUserId } from '../../utils/user';
import { spendPercentage } from '../../utils/business-tools';
import { DateRanges } from '../../utils/DateRanges';
import { getWindow } from '../../utils/general';
import { GetTopSpendByJobName } from '../../hooks/business-tools-hooks';
import '../../styles/business-tools.scss';
import { TopPOJobNameSkeleton } from './BusinessToolsSkeletons';
var generateBarStyles = function (percentage) {
    if (percentage <= 0.2) {
        return percentage > 0 ? { width: '0.2%' } : { width: '0%' };
    }
    return { width: "".concat(percentage, "%") };
};
// map over array and return html and value
var topJobsList = function (jobArray, showMoreJobs, redirectQueryParams, businessToolsHostName, navigate) {
    var denominatorAmount = jobArray[0];
    return jobArray.map(function (job, i) {
        var percentageSpent = spendPercentage(denominatorAmount.totalSpend, job.totalSpend);
        var barStyles = generateBarStyles(percentageSpent);
        var operator = job.totalSpend < 0 ? '-' : '';
        if (showMoreJobs === 0 && i > 4) {
            return true;
        }
        var redirectUrl = redirectQueryParams.startDate
            ? "".concat(businessToolsHostName, "?requestSearchSelectorValue=POJobName&requestSearchCriteria=").concat(job.jobName, "&startDate=").concat(redirectQueryParams.startDate, "&endDate=").concat(redirectQueryParams.endDate, "&dateSelectorValue=").concat(redirectQueryParams.dateSelectorValue)
            : "".concat(businessToolsHostName, "?requestSearchSelectorValue=POJobName&requestSearchCriteria=").concat(job.jobName, "&dateSelectorValue=").concat(redirectQueryParams.dateSelectorValue);
        return (React.createElement("button", { type: "button", onClick: function () {
                var _a, _b;
                // getWindow()?.location.assign(redirectUrl);
                (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem('orderHistoryInfo', JSON.stringify({
                    userId: (_b = getUserId()) !== null && _b !== void 0 ? _b : '',
                    pageSize: 1000,
                }));
                navigate({
                    pathname: '/myaccount/purchase-history/search-results',
                    search: "?search=".concat(encodeURIComponent(job.jobName)),
                });
            }, className: "business-tools__displayBlock", style: { width: '100%' }, key: i },
            React.createElement("li", { className: "business-tools__List", key: i },
                React.createElement("div", { className: "business-tools__Labels u__flex" },
                    React.createElement("span", null, job.jobName !== '' ? job.jobName : 'No Job Name Assigned'),
                    React.createElement("span", null, "".concat(operator, "$").concat(Math.abs(job.totalSpend).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                    })))),
                React.createElement("div", null,
                    React.createElement("div", { className: "business-tools__Bar", style: barStyles })))));
    });
};
// function to load more jobs elements
var showMoreJobsOnClick = function (showMoreJobs, setShowMoreJobs, setHideMe) {
    if (showMoreJobs === 0) {
        setShowMoreJobs(showMoreJobs + 1);
        setHideMe(false);
    }
};
// function to load less jobs elements
var showLessJobsOnClick = function (showMoreJobs, setShowMoreJobs, setHideMe) {
    if (showMoreJobs === 1) {
        setShowMoreJobs(showMoreJobs - 1);
        setHideMe(true);
    }
};
var renderTopByJobsElement = function (jobNameData, jobNameError, jobNameLoaded, topJobsState, redirectQueryParams, businessToolsHostName, navigate) {
    var showMoreJobs = topJobsState.showMoreJobs, hideMe = topJobsState.hideMe, setHideMe = topJobsState.setHideMe, setShowMoreJobs = topJobsState.setShowMoreJobs;
    if (jobNameLoaded) {
        /**
         * Error object if api call catch's axios error in response
         */
        if (jobNameError) {
            return BusinessToolsErrorMessage();
        }
        if (jobNameData && jobNameData.businessToolsResponse.jobsSpend.length > 0) {
            return (React.createElement(React.Fragment, null,
                ' ',
                React.createElement("div", { className: "business-tools__fullWidth u__flex business-tools__subHeader business-tools__marginTop" },
                    React.createElement("h4", null, "Highest to Lowest"),
                    React.createElement("h4", null, "Displays Pre-Tax Dollar Spend")),
                React.createElement("div", { className: "jobs business-tools__marginTop business-tools__fontWeight" },
                    React.createElement("ul", null, topJobsList(jobNameData.businessToolsResponse.jobsSpend, showMoreJobs, redirectQueryParams, businessToolsHostName, navigate))),
                jobNameData.businessToolsResponse.jobsSpend.length > 5 ? (React.createElement("div", { className: "col__6-12 col__3-12--sm business-tools__rmPaddingLeft" }, hideMe ? (React.createElement("button", { type: "button", className: "bttn-outline bttn--link", id: "showMoreJobsElement", onClick: function () {
                        return showMoreJobsOnClick(showMoreJobs, setShowMoreJobs, setHideMe);
                    } },
                    React.createElement("span", { className: "bttn__content" }, "Show more PO/Job Names"))) : (React.createElement("button", { type: "button", className: "bttn-outline bttn--link", id: "showLessJobsElement", onClick: function () {
                        return showLessJobsOnClick(showMoreJobs, setShowMoreJobs, setHideMe);
                    } },
                    React.createElement("span", { className: "bttn__content" }, "Show less"))))) : ('')));
        }
        return (React.createElement(Typography, { weight: "bold" }, "No records can be found for the selected date range and/or job name."));
    }
    return React.createElement(TopPOJobNameSkeleton, null);
};
export var TopJobs = function () {
    var _a = useState(true), hideMe = _a[0], setHideMe = _a[1];
    var _b = useState(0), showMoreJobs = _b[0], setShowMoreJobs = _b[1];
    var navigate = useNavigate();
    var dateRangeOptions = useCommonContext().dateRangeOptions;
    var _c = useBusinessToolsContext(), dateSelectorValue = _c.dateSelectorValue, requestData = _c.requestData, setJobSpends = _c.setJobSpends, businessToolsHostName = _c.businessToolsHostName;
    var request = {
        businessToolsRequest: {
            startDate: dateSelectorValue === 'custom'
                ? dateRangeOptions.startDate
                : DateRanges[dateSelectorValue].startDate,
            endDate: dateSelectorValue === 'custom'
                ? dateRangeOptions.endDate
                : DateRanges[dateSelectorValue].endDate,
            jobName: requestData.poJobName,
        },
        customerAccountId: getSvocId() || '',
    };
    var topJobsState = {
        hideMe: hideMe,
        showMoreJobs: showMoreJobs,
        setHideMe: setHideMe,
        setShowMoreJobs: setShowMoreJobs,
    };
    var _d = GetTopSpendByJobName(request, setJobSpends), jobNameData = _d.jobNameData, jobNameError = _d.jobNameError, jobNameLoaded = _d.jobNameLoaded;
    var redirectQueryParams = {
        startDate: dateSelectorValue === 'custom'
            ? dateRangeOptions.startDate
            : DateRanges[dateSelectorValue].startDate,
        endDate: dateSelectorValue === 'custom'
            ? dateRangeOptions.endDate
            : DateRanges[dateSelectorValue].endDate,
        dateSelectorValue: dateSelectorValue || 'YTD',
        poJobName: requestData.poJobName || '',
    };
    return (React.createElement("div", { className: "top-jobs" },
        React.createElement(SectionHeader, { title: "Top PO/Job Names" }),
        renderTopByJobsElement(jobNameData, jobNameError, jobNameLoaded, topJobsState, redirectQueryParams, businessToolsHostName, navigate)));
};
